import { TouchableOpacity, View } from "react-native";
import { THEME_COLORS } from "../styles";
import React from "react";
import { Dropdown } from "./index";
import { default as CloseIcon } from "@mui/icons-material/CancelRounded";

export interface IModalViewProps {
  show: boolean;
  children: JSX.Element;
  onClose: () => void;
  headerContent: JSX.Element;
  size?: "small" | "medium" | "large";
  headerStyle?: any;
}

const getWidthHeightForSize = (size: string) => {
  let height = "95vh";
  let width = "95vw";
  if (size == "small") {
    height = "65vh";
    width = "45vw";
  } else if (size == "medium") {
    height = "70vh";
    width = "75vw";
  }
  return {
    height,
    width,
  };
};

export const ModalViewNew = (props: IModalViewProps) => {
  const { show, onClose, headerContent } = props;
  if (!show) return null;
  const size = getWidthHeightForSize(props.size);

  return (
    <Dropdown show={show} onClose={onClose} parentRef={null}>
      <View
        style={{
          backgroundColor: THEME_COLORS.bgWhite,
          // position: 'relative',
          height: size.height,
          width: size.width,
          borderRadius: 12,
          flexDirection: "column",
        }}
      >
        <View
          style={[
            {
              width: "100%",
              flexDirection: "row",
              backgroundColor: "#6300A3B2",
              minHeight: "6.5vh",
              borderTopRightRadius: 12,
              borderTopLeftRadius: 12,
              alignItems: "center",
              paddingHorizontal: 30,
            },
            props.headerStyle,
          ]}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>{headerContent}</View>
          <View style={{ flex: 1 }}></View>
          <TouchableOpacity onPress={onClose}>
            <CloseIcon style={{ color: "#ffffff" }} fontSize="medium" />
          </TouchableOpacity>
        </View>
        {props.children}
      </View>
    </Dropdown>
  );
};
